import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class TaskChecklistItemRepositoryService extends BaseRepositoryService<
  ModelRegistry['task-checklist-item']
> {
  recordName = 'task-checklist-item';
  implementMethods = ['createRecord', 'save', 'destroyRecord'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/task-checklist-item': TaskChecklistItemRepositoryService;
  }
}
